import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { isAdminRole } from "../../helpers/employeeRole";
import { getLoggedInEmployee } from "../../services/getLoggedInEmployee";

function AdminRoute({ children }) {
    const [loading, setLoading] = useState(true);
    const [allowed, setAllowed] = useState(false);

    useEffect(() => {
        let mounted = true;

        const checkAccess = async () => {
            const response = await getLoggedInEmployee();
            const role = response?.data?.employeeResponse?.role;

            if (!mounted) return;

            setAllowed(isAdminRole(role));
            setLoading(false);
        };

        checkAccess();

        return () => {
            mounted = false;
        };
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center w-full h-screen">
                <div className="w-12 h-12 border-4 border-gray-200 rounded-full border-t-teal-500 animate-spin"></div>
            </div>
        );
    }

    if (!allowed) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default AdminRoute;
